export default {
  type: "",
  data: {},
  error: "",
  welcome: {}
};
